<template>
  <div class="dialog">
    <el-dialog
      :title="title"
      :visible.sync="show"
      :width="width"
      @close="close"
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
// import utils from '@/services/utils';

export default {
  components: {
    ElDialog: Dialog,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '560px',
    },
    // isDisableClose: {
    //   type: Boolean,
    //   default: false,
    // },
    // isShowFooter: {
    //   type: Boolean,
    //   default: false,
    // },
  },

  data() {
    return {
      show: false,
      isOpenEyeshield: false,
    };
  },
  created() {
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .dialog{
    .el-dialog {
      border-radius: 10px;
      .el-dialog__header {
        background: #5a5fef;
        .el-dialog__title {
          color: #fff;
        }
        .el-dialog__headerbtn {
          width: 22px;
          padding: 2px;
          background: orange;
          border-radius: 50%;
          i{
            color: #fff;
          }
        }
      }
    }
  }
</style>
